import Vue from 'vue'
import VueRouter from 'vue-router'

import EndUser from '../views/EndUser.vue'
import Intro from '../views/Intro.vue'
import Data from '../views/Data.vue'
import Survey from '../views/Survey.vue'
import ClientSurvey from '../views/ClientSurvey.vue'
import SurveyThanks from '../views/SurveyThanks.vue'
import SurveySBPre from '../views/SurveySBPre.vue'
import SurveySBPost from '../views/SurveySBPost.vue'
import SurveyRaptorPre from '../views/SurveyRaptorPre.vue'
import SurveyRaptorPost from '../views/SurveyRaptorPost.vue'
import SurveyBPI from '../views/SurveyBPIClean.vue'
import SurveyMHK from '../views/SurveyMHK.vue'
import SurveyBPIThanks from '../views/SurveyBPIThanks.vue'
import Survey2010JkpgPre from '../views/Survey2010JkpgPre.vue'
import Survey2010JkpgPost from '../views/Survey2010JkpgPost.vue'
import SurveyUppsalaWorkplace from '../views/SurveyUppsalaWorkplace.vue'
import Register from '../views/Register.vue'
import GeneralRegister from '../views/GeneralRegister.vue'
import EmbeddedCard from '../views/EmbeddedCard.vue'

import SurveyBPIPost from '../views/SurveyBPI-post.vue'
import SurveyStrangnas from '../views/Survey-strangnasEl.vue'
import SurveyTranas from '../views/SurveyTranas.vue'
import SurveyBalsta from '../views/survey-balsta.vue'

Vue.use(VueRouter)

const routes = [
	{
		path: '/atervinn', name: 'GeneralRegister', component: GeneralRegister, alias: '/atervinn/'
	},
	{
		path: '/register',
		name: 'Register',
		component: Register
	},
	{
		path: '/client/:slug',
		name: 'ClientSurvey',
		component: ClientSurvey
	},
	{
		path: '/survey/thanks/:slug?',
		name: 'SurveyThanks',
		component: SurveyThanks
	},
	{
		path: '/survey/:slug',
		name: 'Survey',
		component: Survey
	},
	{
		path: '/battreavfallshantering/:slug?',
		name: 'SurveySBPre',
		component: SurveySBPre
	},
	{
		path: '/battreavfallshantering2/:slug?',
		name: 'SurveySBPost',
		component: SurveySBPost
	},
	{
		path: '/balsta/:slug?',
		name: 'SurveyBalsta',
		component: SurveyBalsta
	},
	{
		path: '/enkat/:slug?',
		name: 'Survey2010JkpgPre',
		component: Survey2010JkpgPre
	},
	{
		path: '/enkat2/:slug?',
		name: 'Survey2010JkpgPost',
		component: Survey2010JkpgPost
	},
	{
		path: '/respilot-2022/:slug?',
		name: 'SurveyBPIPost',
		component: SurveyBPIPost
	},
	{
		path: '/s/:slug?',
		name: 'SurveyStrangnas',
		component: SurveyStrangnas
	},
	{
		path: '/tranas/:slug?',
		name: 'SurveyTranas',
		component: SurveyTranas
	},
	{
		path: '/respilot2022/thanks/:slug?',
		name: 'SurveyBPIThanks',
		component: SurveyBPIThanks
	},
	{
		path: '/respilot2022/:slug?',
		name: 'SurveyBPI',
		component: SurveyBPI
	},
	{
		path: '/rsp/:slug?',
		name: 'SurveyRaptorPre',
		component: SurveyRaptorPre
	},
	{
		path: '/rspo/:slug?',
		name: 'SurveyRaptorPost',
		component: SurveyRaptorPost
	},
	{
		path: '/mhkenkat/:slug?',
		name: 'SurveyMHK',
		component: SurveyMHK
	},
	{
		path: '/uwp/:slug?',
		name: 'SurveyUppsalaWorkplace',
		component: SurveyUppsalaWorkplace
	},
	{
		path: '/data/:slug?',
		name: 'Data',
		component: Data
	},
	{
		path: '/:slug',
		name: 'EndUser',
		component: EndUser
	},
	{
		path: '/',
		name: 'Intro',
		component: Intro
	},
	{
		path: '/l/:uri(.*)*',
		redirect: (to) => {
			window.location.href = `${process.env.VUE_APP_API_URL}/l/${to.params.uri}`
		}
	},
	{
		path: '/e/:clientId/:cardId/:slug?',
		name: 'EmbeddedCard',
		component: EmbeddedCard
	},
]

const router = new VueRouter({
	mode: 'history',
	base: process.env.BASE_URL,
	routes
})

export default router
